import { render } from "./ModelVersions.vue?vue&type=template&id=3923c670"
import script from "./ModelVersions.vue?vue&type=script&lang=js"
export * from "./ModelVersions.vue?vue&type=script&lang=js"

import "./ModelVersions.vue?vue&type=style&index=0&id=3923c670&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__